const ROLE = {
  SUPER_ADMIN: "super-admin",
  SUPPORT: "support",
  ORGANIZATION: "organization",
  ADMIN: "admin",
  USER: "user",
  VIEWER: "viewer",
};

const LEGACY_ROLE_MAP = {
  "organization-admin": ROLE.ADMIN,
  "organization-user": ROLE.USER,
  "supera-admin": ROLE.SUPER_ADMIN,
};

export function normalizeRole(role) {
  if (!role) return "";
  return LEGACY_ROLE_MAP[role] || role;
}

export function isSuperAdmin(user) {
  return normalizeRole(user?.role) === ROLE.SUPER_ADMIN;
}

export function isSupport(user) {
  return normalizeRole(user?.role) === ROLE.SUPPORT;
}

export function isOrgAdmin(user) {
  return normalizeRole(user?.role) === ROLE.ADMIN;
}

export function isOrgUser(user) {
  const r = normalizeRole(user?.role);
  return r === ROLE.USER || r === ROLE.VIEWER;
}

export function isOrganization(user) {
  return normalizeRole(user?.role) === ROLE.ORGANIZATION;
}

export function isViewer(user) {
  return normalizeRole(user?.role) === ROLE.VIEWER;
}

export function hasAssignedScreens(user) {
  return Array.isArray(user?.assignedScreens) && user.assignedScreens.length > 0;
}

/** Read-only CMS — only the stored viewer role; screen assignment does not change this. */
export function isEffectiveViewer(user) {
  return isViewer(user);
}

/** Admin Users table label from stored role only. */
export function roleDisplayLabel(user) {
  if (!user) return "User";
  const r = normalizeRole(user.role);
  if (r === ROLE.SUPER_ADMIN) return "Super Admin";
  if (r === ROLE.SUPPORT) return "Notiz Support";
  if (r === ROLE.ORGANIZATION) return "Organization";
  if (r === ROLE.ADMIN) return "Admin";
  if (r === ROLE.VIEWER) return "Viewer";
  if (r === ROLE.USER) return "User";
  return "User";
}

export function canEditCms(user) {
  if (!user) return false;
  return !isEffectiveViewer(user);
}

export function canManageUsers(user) {
  return (
    isSuperAdmin(user) ||
    isSupport(user) ||
    isOrganization(user) ||
    isOrgAdmin(user)
  );
}

/** APK / player package rollout — super-admin only. */
export function canManageSystemSoftware(user) {
  return isSuperAdmin(user);
}

/** Global playlist: super-admin (all tenants) or org admin (own organization only). */
export function canSetGlobalPlaylist(user) {
  if (!user) return false;
  const r = normalizeRole(user.role);
  return r === ROLE.SUPER_ADMIN || r === ROLE.ADMIN;
}

export { ROLE };
